import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_PAGER_VIRTUALIZED_CLASS_NAME = 'TablePagerVirtualized';

export const TABLE_PAGER_VIRTUALIZED_CLASS_SLOTS = ['root'] as const;

export type TablePagerVirtualizedClassSlot =
	(typeof TABLE_PAGER_VIRTUALIZED_CLASS_SLOTS)[number];

export interface TablePagerVirtualizedClasses {
	root: string;
}

export type TablePagerVirtualizedClassKey = keyof TablePagerVirtualizedClasses;

export const getTablePagerVirtualizedUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_PAGER_VIRTUALIZED_CLASS_NAME, slot);

export const tablePagerVirtualizedClasses = generateUtilityClasses<
	keyof TablePagerVirtualizedClasses
>(TABLE_PAGER_VIRTUALIZED_CLASS_NAME, ['root']);
export default tablePagerVirtualizedClasses;
